<template>
  <div>
    <serviceAlert />
    <div class="home container gap" :class="{ inFullStyle: imFull }">
      <div class="home_left">
        <gerenshiming v-show="!imFull" v-if="authType !== 'allAuth'" />
        <div class="gap_2 gap_3" v-show="!imFull" v-if="authType === 'allAuth'">
          <myContract />
          <myInsurance />
        </div>
        <myConsultation />
        <div class="gap_2" v-show="!imFull">
          <industryTrends />
          <breachExposure />
        </div>
        <InformationList isHome />
      </div>
      <div class="home_right" v-show="!imFull">
        <userProfile />
        <signIn />
        <libao />
        <riskAssessment />
        <bannerCarousel />
      </div>
      <newPopup ref="newPopup" />
    </div>
  </div>
</template>

<script>
import serviceAlert from "@/views/Home/components/serviceAlert.vue";

import bannerCarousel from "./components/banner-carousel.vue";
import signIn from "./components/sign-in/sign-in.vue";
import breachExposure from "./components/breach-exposure.vue";
import industryTrends from "./components/industry-trends.vue";
import myConsultation from "./components/my-consultation.vue";
import myContract from "./components/my-contract.vue";
import myInsurance from "./components/my-insurance.vue";
import riskAssessment from "./components/risk-assessment.vue";
import userProfile from "./components/user-profile.vue";
import libao from "@/views/Home/libao.vue";
import gerenshiming from "./components/gerenshiming.vue";
import newPopup from "@/components/newPopup";
import { mapState, mapMutations, mapActions } from "vuex";
import userinfo from "@/mixins/userinfo";
import InformationList from "@/views/Information/components/list.vue";
export default {
  name: "home",
  components: {
    bannerCarousel,
    signIn,
    breachExposure,
    industryTrends,
    myConsultation,
    myContract,
    myInsurance,
    riskAssessment,
    userProfile,
    libao,
    gerenshiming,
    newPopup,
    InformationList,
    serviceAlert,
  },
  mixins: [userinfo],
  data() {
    return {};
  },
  async mounted() {
    this.$store.dispatch("electronic/getContractProfile");
    await this.getAccount();
    if (this.authType == "unAuth") {
      this.toAccountAuth();
    }
    if (this.user.newVersion) {
      this.$refs.newPopup.onshow();
    }
  },
  computed: {
    ...mapState("customerService", ["imFull"]),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  // max-width: 1200px;
  // min-width: 600px;
  box-sizing: border-box;

  @media (min-width: 1448px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.home {
  padding-top: 10px;

  .gap_2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: $padding-md;
  }
  .gap_3 {
    grid-template-columns: 2fr 3fr;
  }
  @media (max-width: 1000px) {
    .gap_2 {
      grid-template-columns: 1fr !important;
      gap: 16px !important;
    }
  }

  &_left {
    flex: 1 1 0;
    min-width: 616px;
    display: flex;
    flex-direction: column;
    row-gap: $padding-md;
  }

  &_right {
    width: 320px;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    row-gap: $padding-md;
    padding-bottom: 20px;
  }
}

.inFullStyle {
  .home_left {
    width: 100%;
  }
}

.gap {
  display: flex;
  gap: $padding-md;
  flex-wrap: nowrap; // 保持横向排列
}
</style>
